import ComponentModule from "@eisinc/Overrides/Components/CustomerSelector";

export * from "@eisinc/Overrides/Components/CustomerSelector";

export default ComponentModule;
